import * as actionTypes from 'Constants/redux';

export function setPicklistFilter(filter) {
  return (dispatch) =>
    dispatch({
      type: actionTypes.SET_PICKLIST_FILTER,
      payload: { filter },
    });
}
